import script from "./forms.vue?vue&type=script&setup=true&lang=js"
export * from "./forms.vue?vue&type=script&setup=true&lang=js"

import "./forms.vue?vue&type=style&index=0&id=7e81f2a2&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/campus-heating-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e81f2a2"]])

export default __exports__